import { AiMatchingScore } from "../../../pages";
import adminRouteMap from "../../../routeControl/adminRouteMap";

export default function route() {
  return [
    {
      path: `${adminRouteMap.AI_MATCHING_SCORE.path}/:id`,
      name: "Ai Matching Score",
      key: `${adminRouteMap.AI_MATCHING_SCORE.path}/:id`,
      commonRoute: false,
      private: true,
      belongsToSidebar: false,
      element: <AiMatchingScore />,
    },
  ];
}
